/**
 *
 *  Specialisation Item on Homepage
 *
 *  Created by Vladimir Shishlyannikov on 25/10/2023.
 *  Copyright (c) 2023-present iWoo Ltd. All rights reserved.
 *
 */

import React, { useCallback } from "react";

// Hooks
import useContentScrollerItem from "../../../hooks/useContentScrollerItem/useContentScrollerItem";

export default function SpecialisationItem({
  active,
  specialisationInfo,
  // children,
  contentScrollerApi,
  isContentScrollerVisible,
  itemKey,
  onSpecialisationVisible,
  onSpecialisationVisibleChange,
  onSpecialisationClick,
  // tabIndex,
}) {
  const specialisationItemRef = React.useRef(null);

  const handleClick = useCallback(
    (e) => {
      onSpecialisationClick && onSpecialisationClick(specialisationInfo, e);
    },
    [specialisationInfo, onSpecialisationClick]
  );

  useContentScrollerItem({
    contentScrollerApi: contentScrollerApi,
    element: specialisationItemRef.current,
    isScrollerVisible: isContentScrollerVisible,
    key: itemKey,
    onItemVisible: onSpecialisationVisible,
    onItemVisibleChange: onSpecialisationVisibleChange,
    threshold: 0.5,
  });

  return (
    <div
      className={`specialisation-item tbk-flex tbk-h-32 tbk-w-24 tbk-cursor-pointer tbk-flex-col tbk-items-center tbk-pt-1.5 tbk-pb-0.5 tbk-text-center${
        active
          ? " active tbk-border-b-4 tbk-border-coral tbk-text-basic-trueblack"
          : " tbk-text-blue-grey"
      } hover:tbk-text-basic-trueblack`}
      ref={specialisationItemRef}
      onClick={handleClick}
    >
      <img
        width={64}
        height={64}
        src={specialisationInfo.photo}
        alt={specialisationInfo.name}
      />
      <div className="tbk-text-secondary tbk-text-center">
        {specialisationInfo.name}
      </div>
    </div>
  );
}
